import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useI18N } from "@sundae/react-hooks";
import { Image, Text } from "@sundae/ui-toolkit";
import cx from "classnames";
const NoDataIndicator = ({ containerClassName, context, imageClassName, imageMaxWidth = 92, size = "sm", }) => {
    const { t } = useI18N("warnings");
    return (_jsxs("div", { className: cx("flex w-full flex-col items-center gap-2 p-4", containerClassName), children: [_jsx(Image, { src: "/static/images/dudes/froyo_confused_sad_400x400.png", className: cx(imageClassName), style: { maxWidth: `${imageMaxWidth}px` } }), _jsx(Text, { className: "text-center", size: size, tag: "p", children: t("noData", { context }) })] }));
};
export default NoDataIndicator;
//# sourceMappingURL=NoDataIndicator.js.map